import { lazy } from 'react';
import { Permission, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer ist React.lazy,
 * sodass die Versions-Timeline erst lädt, wenn der Sidebar-Slot rendert.
 */
const manifest: SkillManifest = {
  key: 'project-versioning',
  name: 'Projekt-Versionierung',
  description:
    'Snapshots des Projektzustands beim Abschluss + manuelle Neue-Version-anlegen — füllt die Sidebar im Project-Detail.',
  category: 'collaboration',
  version: '0.1.0',
  requiredPermissions: [Permission.PROJECT_READ, Permission.PROJECT_UPDATE],
  enabledByDefault: true,
};

const VersionTimeline = lazy(() =>
  import('./VersionTimeline').then((m) => ({ default: m.VersionTimeline })),
);

export const projectVersioningSkill: FrontendSkill = {
  manifest,
  slots: {
    'project-detail.sidebar': [
      {
        key: 'version-timeline',
        // Block „selten" der Projekt-Sidebar (order ≥ 71, s. ProjectDetailPage):
        // der Verlauf ist Nachschau — er gehört ans Ende, nicht in den Blick
        // beim Bearbeiten.
        order: 90,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId, readOnly, projectStatus
        render: VersionTimeline,
      },
    ],
  },
};
